import React from 'react';
import { ArrowRight, Calendar, User } from 'lucide-react';

const Blog: React.FC = () => {
    const posts = [
        {
            title: "Comment rédiger un CV parfait en 2024",
            excerpt: "Découvrez les astuces incontournables pour faire sortir votre CV du lot cette année.",
            date: "12 Jan 2024",
            author: "Jean Dupont",
            image: "https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&q=80&w=600"
        },
        {
            title: "Les erreurs à éviter en entretien",
            excerpt: "Préparez-vous efficacement pour vos entretiens d'embauche avec nos conseils d'experts.",
            date: "10 Jan 2024",
            author: "Marie Curie",
            image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=600"
        },
        {
            title: "L'importance de la lettre de motivation",
            excerpt: "Pourquoi la lettre de motivation reste un atout majeur pour votre candidature.",
            date: "05 Jan 2024",
            author: "Paul Martin",
            image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=600"
        }
    ];

    return (
        <section id="blog" className="py-20 bg-gray-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-16">
                    <h4 className="text-blue-600 font-semibold uppercase tracking-wider mb-2">Blog & Actualités</h4>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Derniers Articles</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {posts.map((post, index) => (
                        <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow group">
                            <div className="relative overflow-hidden h-60">
                                <img
                                    src={post.image}
                                    alt={post.title}
                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                />
                                <div className="absolute top-4 left-4 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                                    Conseils
                                </div>
                            </div>
                            <div className="p-6">
                                <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
                                    <div className="flex items-center space-x-1">
                                        <Calendar size={14} />
                                        <span>{post.date}</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                        <User size={14} />
                                        <span>{post.author}</span>
                                    </div>
                                </div>
                                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                                    {post.title}
                                </h3>
                                <p className="text-gray-600 mb-6 line-clamp-2">
                                    {post.excerpt}
                                </p>
                                <button className="flex items-center text-blue-600 font-semibold hover:text-blue-700 transition-colors">
                                    Lire la suite <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Blog;
